import { createAction } from 'typesafe-actions';

export const fetchCountriesRequest = createAction('countries/COUNTRIES_FETCH_REQUEST')();
export const fetchCountriesSuccess = createAction('countries/COUNTRIES_FETCH_SUCCESS')<Responses.Countries>();
export const fetchCountriesFailed = createAction('countries/COUNTRIES_FETCH_FAILED')();
